// DataArrayNodeModal.js
import React, { useState } from "react";
import Modal from "../base/Modal";

const DataArrayNodeModal = ({ mode, nodeData, onSave, onDelete, onClose, viewOnly }) => {
  const [purpose, setPurpose] = useState(nodeData?.data?.purpose || "");
  const [elementDetails, setElementDetails] = useState(nodeData?.data?.elementDetails || "");

  const handleSave = () => {
    const updatedNode = {
      ...nodeData,
      data: {
        ...(nodeData?.data || {}),
        purpose,
        elementDetails,
      },
    };
    onSave(updatedNode);
  };

  return (
    <Modal
      title={
        viewOnly
          ? "Data Array Node"
          : mode === "add"
          ? "Add Data Array Node"
          : "Edit Data Array Node"
      }
      isOpen={true}
      onClose={onClose}
    >
      <div className="p-6 bg-zinc-800 text-zinc-100 rounded shadow-lg overflow-auto">
        {/* Purpose Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Purpose</label>
          <textarea
            className="w-full p-2 bg-zinc-700 border border-zinc-600 rounded focus:outline-none focus:ring-2 focus:ring-[#5652CF]"
            placeholder="Describe the purpose for splitting the data (e.g., to generate individual email elements)."
            value={purpose}
            disabled={viewOnly}
            onChange={(e) => setPurpose(e.target.value)}
            rows={3}
          />
        </div>

        {/* Element Details Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Element Details</label>
          <textarea
            className="w-full p-2 bg-zinc-700 border border-zinc-600 rounded focus:outline-none focus:ring-2 focus:ring-[#5652CF]"
            placeholder="Specify the complete structure each element must have (e.g., recipient, name, custom message, etc.)."
            value={elementDetails}
            disabled={viewOnly}
            onChange={(e) => setElementDetails(e.target.value)}
            rows={3}
          />
        </div>

        {/* Action Buttons */}
        {!viewOnly && (
          <div className="flex justify-end gap-3 mt-4">
            {mode === "edit" && (
              <button
                className="px-4 py-2 bg-zinc-700 text-zinc-300 hover:bg-zinc-600 rounded"
                onClick={() => onDelete(nodeData.id)}
              >
                Delete Node
              </button>
            )}
            <button
              className="px-4 py-2 bg-zinc-700 text-zinc-300 hover:bg-zinc-600 rounded"
              onClick={handleSave}
            >
              {mode === "add" ? "Add Node" : "Save Changes"}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DataArrayNodeModal;
